<template>
  <section data-luko-tracking="Page-Advice">
    <AdvicesHubModule
      :module-data="{ hubSlices, article: [], allCategories }"
    />
  </section>
</template>

<script>
import { pipe, map, toAsync, filter, toArray, concurrent } from '@fxts/core'

import { formatMetaDatas } from '~/utils/metaData'
import AdvicesHubModule from '~/modules/AdvicesHub'

export default {
  name: 'AdviceHub',

  head() {
    const heroData = this.hubContent.body.find(
      (s) => s.slice_type === 'hero'
    )?.primary

    const defaultMeta = {
      twitter_title: heroData?.title[0].text,
      twitter_description: heroData?.subtitle[0].text,
      twitter_image: heroData?.background?.url,
    }

    return formatMetaDatas(this.metaDatas, this.$route.path, defaultMeta)
  },

  components: {
    AdvicesHubModule,
  },

  async asyncData({ app, $prismic, store, error }) {
    try {
      const { data: hubContent, alternate_languages } =
        await $prismic.api.getByUID('hub_page', 'advice-hub', {
          lang: app.i18n.localeProperties.prismicIso,
        })
      // Extract page settings from PageSettings slice.
      store.commit(
        'page/UPDATE',
        hubContent.body.find((s) => s.slice_type === 'page_settings')
      )
      hubContent.body = hubContent.body.filter(
        (s) => s.slice_type !== 'page_settings'
      )

      store.dispatch('setAlternateLanguages', alternate_languages)

      // Get the last 3 articles for each category
      const categoryIds = Object.keys(store.state.adviceCategoryData)
      const allCategories = await pipe(
        categoryIds,
        toAsync,
        map(async (categoryId) => {
          const { results } = await $prismic.api.query(
            [
              $prismic.predicates.at('document.type', 'advice_page'),
              $prismic.predicates.at(
                'my.advice_page.category_page',
                categoryId
              ),
            ],
            {
              lang: app.i18n.localeProperties.prismicIso,
              pageSize: 3,
            }
          )
          return {
            categoryId,
            articles: results,
          }
        }),
        concurrent(categoryIds.length),
        filter((category) => category.articles.length > 0),
        toArray
      )

      const hubSlices = await Promise.all(
        hubContent.body.map(async (slice) => {
          if (slice.slice_type !== 'news') return slice

          const ids = slice.items
            .map((item) => {
              return item.articles.id
            })
            .filter((id) => !!id) // filter empty article which isn't filled in prismic

          const { results: newsArticles } = await $prismic.api.getByIDs(ids)

          return {
            ...slice,
            items: newsArticles,
          }
        })
      )

      return {
        hubContent,
        hubSlices,
        allCategories,
        metaDatas: hubContent.body1 || [],
      }
    } catch (e) {
      console.log(e)
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
